import CircularProgress from '@mui/material/CircularProgress';

const LoadingScreen = () => {
	return (
		<div
			style={{
				margin: 'auto',
				display: 'flex',
				marginTop: 100,
				justifyContent: 'center',
			}}
		>
			<CircularProgress />
		</div>
	);
};

export default LoadingScreen;
